import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Button, makeStyles, } from '@material-ui/core';
import clsx from 'clsx';
import { useModePanelStyle, } from '../../style';
import { CompCustomActionsMenu, } from './CompCustomActionsMenu';
import { FontIcon, } from './FontIcon';
const useStyle = makeStyles((theme) => {
    return {
        icon: {
            '&.clickable': {
                cursor: 'pointer',
            },
        },
        title: {
            '&.clickable': {
                cursor: 'pointer',
            },
        },
        action: {
            '&.info': {
                backgroundColor: theme.palette.info.main,
                color: theme.palette.info.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.info.light,
                },
            },
            '&.success': {
                backgroundColor: theme.palette.success.main,
                color: theme.palette.success.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.success.light,
                },
            },
            '&.warning': {
                backgroundColor: theme.palette.warning.main,
                color: theme.palette.warning.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.warning.light,
                },
            },
            '&.error': {
                backgroundColor: theme.palette.error.main,
                color: theme.palette.error.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.error.light,
                },
            },
        },
    };
});
/**
 * This is a Generic Header component that can be used for most of the InfoComponent. Most InfoComponent has a title, icon,
 * Edit button so they can use this Component instead of repeating this code
 * @param props
 */
export const InfoCompPanelHeader = (props) => {
    var _a, _b, _c;
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    if (props.headerless) {
        return (_jsx(_Fragment, {}));
    }
    return (_jsxs("div", { className: clsx(panelClasses.panelHeader, props.headerClassName, props.borderlessHeader && 'borderless'), children: [_jsxs("div", { className: panelClasses.panelHeaderLeft, children: [props.icon && (_jsx("div", { className: clsx(panelClasses.panelHeaderIconContainer, classes.icon, props.onIconClick && 'clickable'), onClick: props.onIconClick, children: _jsx(FontIcon, { className: clsx(panelClasses.panelHeaderIcon), iconName: props.icon }) })), (props.title || props.subtitle) && (_jsxs("div", { className: clsx(panelClasses.panelHeaderTitle, classes.title, props.onTitleClick && 'clickable'), onClick: props.onTitleClick, children: [props.title && _jsx("div", { className: "title", children: props.title }), props.subtitle && _jsx("div", { className: "subtitle", children: props.subtitle })] }))] }), _jsxs("div", { className: panelClasses.panelHeaderRight, children: [props.customContent, ((_a = props.actions) === null || _a === void 0 ? void 0 : _a.startEdit) && !props.isEditing && (_jsx(IconButton, { size: "small", onClick: () => {
                            var _a;
                            if ((_a = props.actions) === null || _a === void 0 ? void 0 : _a.startEdit) {
                                props.actions.startEdit.onClick();
                            }
                        }, children: _jsx(FontIcon, { iconName: props.actions.startEdit.icon || 'edit' }) })), ((_b = props.actions) === null || _b === void 0 ? void 0 : _b.removeObject) && !props.isEditing && (_jsx(IconButton, { color: "secondary", size: "small", onClick: () => {
                            var _a;
                            if ((_a = props.actions) === null || _a === void 0 ? void 0 : _a.removeObject) {
                                props.actions.removeObject.onClick();
                            }
                        }, children: _jsx(FontIcon, { iconName: props.actions.removeObject.icon || 'delete_outline' }) })), !props.isEditing && ((_c = props.customPrimaryActions) === null || _c === void 0 ? void 0 : _c.map((action) => {
                        if (action.icon && !action.label) {
                            return (_jsx(IconButton, { className: clsx(panelClasses.panelHeaderCustomPrimaryAction, classes.action, action.type), color: "primary", size: "small", onClick: () => {
                                    action.onClick();
                                }, children: _jsx(FontIcon, { iconName: action.icon }) }, `${action.icon}-${action.label}`));
                        }
                        return (_jsx(Button, { className: clsx(panelClasses.panelHeaderCustomPrimaryAction, classes.action, action.type), color: "primary", size: "small", startIcon: action.icon ? _jsx(FontIcon, { iconName: action.icon }) : undefined, onClick: () => {
                                action.onClick();
                            }, children: action.label }, `${action.icon}-${action.label}`));
                    })), props.endCustomContent, props.customSecondaryActions && !props.isEditing && (_jsx(CompCustomActionsMenu, { customActions: props.customSecondaryActions }))] })] }));
};
/**
 * This is a Generic Header component that can be used for most of the InfoComponent. Most InfoComponent has a title, icon,
 * Edit button so they can use this Component instead of repeating this code
 * @param props
 */
export const CompPanelHeader = (props) => {
    var _a;
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    if (props.headerless) {
        return (_jsx(_Fragment, {}));
    }
    return (_jsxs("div", { className: clsx(panelClasses.panelHeader, props.headerClassName, props.borderlessHeader && 'borderless'), children: [_jsxs("div", { className: panelClasses.panelHeaderLeft, children: [props.icon && (_jsx("div", { className: clsx(panelClasses.panelHeaderIconContainer, classes.icon, props.onIconClick && 'clickable'), onClick: props.onIconClick, children: _jsx(FontIcon, { className: clsx(panelClasses.panelHeaderIcon), iconName: props.icon }) })), (props.title || props.subtitle) && (_jsxs("div", { className: clsx(panelClasses.panelHeaderTitle, classes.title, props.onTitleClick && 'clickable'), onClick: props.onTitleClick, children: [props.title && _jsx("div", { className: "title", children: props.title }), props.subtitle && _jsx("div", { className: "subtitle", children: props.subtitle })] }))] }), _jsxs("div", { className: panelClasses.panelHeaderRight, children: [props.customContent, (_a = props.customPrimaryActions) === null || _a === void 0 ? void 0 : _a.map((action) => {
                        if (action.icon && !action.label) {
                            return (_jsx(IconButton, { className: clsx(panelClasses.panelHeaderCustomPrimaryAction, classes.action, action.type), color: action.color, size: "small", onClick: () => {
                                    action.onClick();
                                }, children: _jsx(FontIcon, { iconName: action.icon }) }, `${action.icon}-${action.label}`));
                        }
                        return (_jsx(Button, { className: clsx(panelClasses.panelHeaderCustomPrimaryAction, classes.action, action.type), color: action.color, variant: action.variant, size: "small", startIcon: action.icon ? _jsx(FontIcon, { iconName: action.icon }) : undefined, onClick: () => {
                                action.onClick();
                            }, children: action.label }, `${action.icon}-${action.label}`));
                    }), props.endCustomContent, props.customSecondaryActions && (_jsx(CompCustomActionsMenu, { customActions: props.customSecondaryActions }))] })] }));
};
